<style>
  .alert{
  transition-duration:1s; /* <= creates fade out effect */
  transition-delay:1s;
}
</style>

<template>
    
    <div>
        

        <div  >
            <form @submit.prevent="processBarcode()" autocomplete="off">
                <div class="field " v-if="loading==false">
                    <label class="label">Location</label>
                    <div class="select is-fullwidth">
                        <select v-model="location_id" class="input "  :disabled="working==true">
                            <option value="">Select location ...</option>
                            <option value="1">Strabane</option>
                            <option value="4">Derry</option>
                        </select>
                    </div>
                </div>
                <div class="field " v-if="loading==false">
                    <label class="label">Makeup User</label>
                    <div class="select is-fullwidth">
                        <select v-model="user_id" class="input " @change="focusInput()" required :disabled="working==true">
                            <option value="">Select user ...</option>
                            <option v-for="row in filteredUsers" :key="row.id" :value="row.userID">{{ row.firstname }} {{  row.surname }}</option>
                        </select>
                    </div>
                </div>

                <div class="notification is-warning" v-if="loading == true">
                    Loading users ...
                </div>

                <div class="field " >
                    <label class="label">Date</label>
                    <div class="select is-fullwidth">
                        <input v-model="scan_date" type="date" class="input" :disabled="working==true"/>
                    </div>
                </div>

                
             
                <div class="field ">
                    <label class="label">Barcode Scan</label>
                   <input class="input is-large" type="text" :disabled="working==true" placeholder="Enter bundle code here" v-model="bundle_code" ref="makeup_data_input" autocomplete="off" required><br /><br />
                    <button class="button is-large is-fullwidth " :disabled="working==true || loading==true" :class="{'is-info': this.working==true, 'is-success' : this.working == false}" >Process</button>
                </div>
                
            </form>

            <br /><br />

            <h2 class="title">Recent Actions Log <span v-if="validCounter > 0"> - {{  validCounter }} successful</span></h2>
            <span v-for="(row, index) in actions_log" :key="index" :class="{'has-text-danger':row.error === true}">{{ row.label}}<br /></span>

            
        </div>
        
    </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
 name: 'ProductivityScanning',
  mixins: [OrderMixin],
  data() {
    
    return {
      order: {orderID: 0},
      loading: true,
      bundle_code: '',
      access_token: '',
      processed:false,
      actions_log : [],
      makeup_input_location_id: '',
      operations: '',
      users: [],
      user_id: '',
      working: false,
      validCounter: 0,
      scan_date : this.getStartDate(),
      location_id: 1
      
    }
  },
   methods: {
      getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() );
            return d.toISOString().slice(0,10);
            
        },
      async processBarcode()
      {
          this.working = true

            var formdata = { 
                bundle_code: this.bundle_code,
                user_id : this.user_id,
                date: this.scan_date
            }; 

            OrderService.productivityScanInputData(this.accessToken, formdata)
            .then((response) => {
                //this.getOrder()
                console.log(response)
                
                this.actions_log.unshift({label : this.bundle_code + " scanned successfully for operation " + response.operation_label, error: false})

                this.bundle_code = ''
                this.focusInput()

                this.working = false
                this.validCounter++;
            }).catch((error) => {
              if(error.response.status == 409)
              {
                this.actions_log.unshift({label : "Error - " + this.bundle_code + " - " + error.response.data.error_message, error : true})
              }
              else if(error.response.status == 400)
              {
                console.log(error.response)
                this.actions_log.unshift({label : "Error - " + this.bundle_code + " not valid - " + error.response.data.error_message, error : true})
              }
              else {
                alert("Something went wrong and the data has not been saved. Please reload and try again")
                console.log("Error:" + JSON.stringify(error.response.data));
              }
              this.bundle_code = ''
                this.focusInput()
                
                this.working = false
            });
            
            
           
            
           
      },
      
      focusInput() {
          this.$nextTick(() => this.$refs.makeup_data_input.focus())
      }
     
   },
   mounted() {
    if (localStorage.productivity_scanning_location_id) {
      this.location_id = localStorage.productivity_scanning_location_id;
    }
    else{
      this.location_id = ''
    }
      
  },
  watch: {
    'location_id'() {
      localStorage.productivity_scanning_location_id = this.location_id
    },
    
  },
  computed: {
    filteredUsers() {
      if (this.location_id && this.location_id !== 0) {
        return Object.fromEntries(
          Object.entries(this.users).filter(
            ([, user]) => user.user_location_id == this.location_id
          )
        );
      }
      else {
        return this.users;
      }
    }
  },
  
  created() {
     this.getAccessToken()
        .then(() => { 
          this.getMakeupUsers();
          this.focusInput();
        });

        
  },
}
</script>